var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: {
        padding: "20px 15px 20px 15px",
        "background-color": "#ffffff"
      }
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "title-confirmation-selection" }, [
                  _vm._v("Congratulations!")
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "margin-top": "20px",
                    display: "flex",
                    "justify-content": "center"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c("el-image", {
                    staticStyle: {
                      "max-height": "582px",
                      "max-width": "1544px",
                      "border-radius": "0 0 20px 20px",
                      "box-shadow": "5px 5px 10px rgba(0, 0, 0, 0.5)"
                    },
                    attrs: {
                      src: require("../../assets/similar-search-1.jpg"),
                      fit: "fill"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "10px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c("el-row", [
                            _c(
                              "span",
                              { staticClass: "para-confirmation-selection" },
                              [
                                _vm._v(
                                  "Congratulations on taking the first step in your property\n                purchase."
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "10px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "para-confirmation-selection" },
                            [
                              _vm._v(
                                "Your agent will be in touch with you shortly to discuss the\n              next steps."
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            display: "flex",
                            "flex-direction": "column"
                          },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-return-home",
                              on: { click: _vm.redirectToHome }
                            },
                            [_vm._v("Return Home")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d1f0618", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1f0618","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservation/confirmationSelection.vue
// module id = null
// module chunks = 